import { DiscountActionTargetTypeEnum, ProductType } from "app/shared/model";
import { ProductFilterType, SelectionMap } from "app/shared/model/ProductFilter";
import { DiscountTarget, SavedDiscountAction } from "app/pages/DiscountEditor/modules/DiscountActions/state";

export function buildSeededDiscountTarget(
    type: DiscountActionTargetTypeEnum,
    existingActions: SavedDiscountAction[]
): DiscountTarget {
    switch (type) {
        case DiscountActionTargetTypeEnum.ApplicableProducts:
            return { type: DiscountActionTargetTypeEnum.ApplicableProducts };

        case DiscountActionTargetTypeEnum.Fees: {
            const fees: SelectionMap = {};
            existingActions.forEach(a => {
                const target = a.target;
                if (target.type !== DiscountActionTargetTypeEnum.Fees) return;
                Object.keys(target.fees).forEach(code => {
                    if (target.fees[code]) fees[code] = true;
                });
            });
            return { type: DiscountActionTargetTypeEnum.Fees, fees };
        }

        case DiscountActionTargetTypeEnum.OtherProducts: {
            const productCodes: SelectionMap = {};
            let productType = ProductType.Course;
            let filterType: ProductFilterType.IncludeSpecific | ProductFilterType.ExcludeSpecific =
                ProductFilterType.IncludeSpecific;
            let foundSpecific = false;

            existingActions.forEach(a => {
                const target = a.target;
                if (target.type !== DiscountActionTargetTypeEnum.OtherProducts) return;
                const products = target.products;
                if (
                    products.type !== ProductFilterType.IncludeSpecific &&
                    products.type !== ProductFilterType.ExcludeSpecific
                ) {
                    return;
                }
                if (!foundSpecific) {
                    filterType = products.type;
                    productType = products.productType;
                    foundSpecific = true;
                }
                if (products.type === filterType && products.productType === productType) {
                    Object.keys(products.productCodes).forEach(code => {
                        if (products.productCodes[code]) productCodes[code] = true;
                    });
                }
            });

            return {
                type: DiscountActionTargetTypeEnum.OtherProducts,
                products: {
                    type: filterType,
                    productType,
                    productCodes,
                },
            };
        }

        default:
            throw new Error("Unknown discount action target type: " + type);
    }
}